/**
 * Translates a bundle into multiple versions of it with correct mount mergedIn
 * @param {Object} bundle a inventory bundle as it is in the CMS
 */
export function translateToSelectedMountBundle(bundle) {
  const { productMounts, id, ...strippedBundle } = bundle;
  const mounts = productMounts || [{}];
  const bundleVersion = mounts.map(mount => {
    return {
      ...strippedBundle,
      id,
      selectedMount: { ...mount?.mount, id: mount?.id },
      price: mount.price || bundle.price,
      leasingPrice: mount.leasingPrice || bundle.leasingPrice,
      image: mount.mount?.image || bundle.product?.images[0].image,
      thumbnail: mount.mount?.thumbnail || bundle.product?.images[0].image,
    };
  });

  return bundleVersion;
}
